// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"f5008b3d","174":"bf95892b","488":"34c37b35","719":"d8035309","794":"cc0ff3dc","820":"077e1590","895":"6b90ff85","982":"79883d6e"}[chunkId] + ".chunk.js";
};